import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { BookOpen } from 'lucide-react';
import { api } from '../../nucleo/api';

/** Raiz das telas do módulo: menu `treinamento`, módulo `treinamento`. */
export const BASE = '/treinamento/treinamento';

/** Barra de progresso de 0 a 100 (cor só por token). */
export function BarraProgresso({ valor, rotulo, nome }: { valor: number; rotulo?: boolean; nome?: string }) {
  const { t } = useTranslation('treinamento');
  const v = Math.max(0, Math.min(100, Math.round(valor)));
  return (
    <div className="flex min-w-0 items-center gap-3">
      {/* r8 visual B9: a barra tem nome acessível (aria-progressbar-name). */}
      <div role="progressbar" aria-label={nome ?? t('abas.progresso')} aria-valuemin={0} aria-valuemax={100} aria-valuenow={v} className="h-2 min-w-0 flex-1 overflow-hidden rounded-full bg-sup-3">
        <div className={`h-full rounded-full ${v === 100 ? 'bg-verde' : 'bg-acento-forte'}`} style={{ width: `${v}%` }} />
      </div>
      {rotulo !== false && <span className="numero w-10 shrink-0 text-right text-xs text-tinta-2">{v}%</span>}
    </div>
  );
}

/** Capa do curso (anexo do núcleo) ou um marcador quando não há capa. */
export function Capa({ anexoId, titulo }: { anexoId: string | null; titulo: string }) {
  if (anexoId) return <img src={`/api/v1/anexos/${anexoId}`} alt={titulo} loading="lazy" className="size-full object-cover" />;
  return (
    <div className="flex size-full items-center justify-center bg-sup-2 text-tinta-3" aria-hidden>
      <BookOpen className="size-8" />
    </div>
  );
}

/** Envia um anexo pelo núcleo (POST /anexos) para um registro do módulo e devolve o id do anexo. */
export async function enviarAnexo(entidade: 'treinamento.curso' | 'treinamento.aula', registroId: string, arquivo: File): Promise<string> {
  const fd = new FormData();
  fd.append('entidade', entidade);
  fd.append('registro_id', registroId);
  fd.append('arquivo', arquivo);
  const r = await api<{ id: string }>('POST', '/anexos', fd);
  return r.id;
}

/** Botão só de ícone, com rótulo para leitor de tela e dica. */
export function BotaoIcone({ rotulo, icone, onClick, disabled, perigo }: { rotulo: string; icone: ReactNode; onClick: () => void; disabled?: boolean; perigo?: boolean }) {
  return (
    <button
      type="button"
      aria-label={rotulo}
      title={rotulo}
      disabled={disabled}
      onClick={onClick}
      className={`rounded p-1.5 text-tinta-3 hover:bg-sup-3 disabled:cursor-not-allowed disabled:opacity-40 ${perigo ? 'hover:text-perigo' : 'hover:text-tinta-1'}`}
    >
      {icone}
    </button>
  );
}
